import React, { useState } from "react";
import AdvantagesImage from "../../Assets/Images/Advantage.svg"
// import { Accordion, AccordionTab } from 'primereact/accordion';
import { MDBAccordion, MDBAccordionItem } from 'mdb-react-ui-kit';
import { Card } from "react-bootstrap";

const AdvantagesOfPosp = () => {
    const [active, setActive] = useState(1);
    return (
        <div className=" mb-5 pt-5 pb-5" style={{ backgroundColor: "#F7F7F7" }}>
            <div className="advantage-heading">
                <h1>Advantages of Being A POSP</h1>
            </div>
            <div className="container ">
                <div className="row">

                    <div className="col-md-5 col-sm-12 pt-4 ">
                        <div className="d-flex justify-content-center">
                            <img src={AdvantagesImage} alt="advantage" className="advantage-posp" />
                        </div>
                    </div>
                    <div className="col-md-7 scol-sm-12 pt-4">

                        <MDBAccordion active={active} onChange={(itemId) => setActive(itemId)}>
                            <MDBAccordionItem collapseId={1} headerTitle='Lucrative Commissions'>
                                Unlock financial prosperity by selling insurance policies as a
                                PoSP, where your dedication directly translates into substantial
                                income through attractive commission structures.{" "}
                            </MDBAccordionItem>
                            <MDBAccordionItem collapseId={2} headerTitle='Freedom and Autonomy'>
                                Enjoy unparalleled flexibility as a PoSP, shaping your work
                                schedule to fit seamlessly into your lifestyle, granting you the
                                freedom to pursue personal passions while excelling
                                professionally.
                            </MDBAccordionItem>
                            <MDBAccordionItem collapseId={3} headerTitle='Endless Growth Opportunities'>
                                Step into a realm of perpetual learning and advancement as a PoSP,
                                where each day presents new chances to refine your sales prowess
                                and expand your expertise within the dynamic insurance landscape.
                            </MDBAccordionItem>
                            <MDBAccordionItem collapseId={4} headerTitle='Making a Meaningful Impact'>
                                Embrace the noble responsibility of safeguarding individuals and
                                families against life's uncertainties as a PoSP, ensuring their
                                peace of mind and financial security through every policy sold.
                            </MDBAccordionItem>
                        </MDBAccordion>

                    </div>

                    {/* <div className="col-md-6 scol-sm-12 pt-4">
                        <div className="pt-4 d-flex align-item-center justify-content-center flex-column">
                            <div className="d-flex gap-1 align-item-center">
                                <div className="d-flex align-items-center justify-content-center gap-1">
                                    <FaRegDotCircle className="" />
                                    <h5 className="m-0" style={{color:"#1b3d58", fontWeight:"500"}}>Lucrative Commissions</h5>
                                </div>
                            </div>
                            <p className="mt-1"style={{ paddingLeft: "20px", fontSize: "small" }}>
                                Unlock financial prosperity by selling insurance policies as a
                                POSP, where your dedication directly translates into substantial
                                income through attractive commission structures.{" "}
                            </p>
                        </div>
                        <div>
                            <div className="d-flex gap-1 align-item-center">
                                <div className="d-flex align-items-center justify-content-center gap-1">
                                    <FaRegDotCircle className="" />
                                    <h5 className="m-0" style={{color:"#1b3d58" ,fontWeight:"500"}}>Freedom and Autonomy</h5>
                                </div>
                            </div>
                            <p className="mt-1"style={{ paddingLeft: "20px", fontSize: "small" }}>
                                Enjoy unparalleled flexibility as a POSP, shaping your work
                                schedule to fit seamlessly into your lifestyle, granting you the
                                freedom to pursue personal passions while excelling
                                professionally.
                            </p>
                        </div>
                        <div>
                            <div className="d-flex gap-1 align-item-center">
                                <div className="d-flex align-items-center justify-content-center gap-1">
                                    <FaRegDotCircle className="" />
                                    <h5 className="m-0" style={{color:"#1b3d58" ,fontWeight:"500"}}>c</h5>
                                </div>
                            </div>
                            <p className="mt-1"style={{ paddingLeft: "20px", fontSize: "small" }}>
                                Step into a realm of perpetual learning and advancement as a POSP,
                                where each day presents new chances to refine your sales prowess
                                and expand your expertise within the dynamic insurance landscape
                            </p>
                        </div>
                        <div>
                            <div className="d-flex gap-1 align-item-center">
                                <div className="d-flex align-items-center justify-content-center gap-1">
                                    <FaRegDotCircle className="" />
                                    <h5 className="m-0" style={{color:"#1b3d58" ,fontWeight:"500"}}>Making a Meaningful Impact</h5>
                                </div>
                            </div>
                            <p className="mt-1"style={{ paddingLeft: "20px", fontSize: "small" }}>
                                Embrace the noble responsibility of safeguarding individuals and
                                families against life's uncertainties as a POSP, ensuring their
                                peace of mind and financial security through every policy sold.
                            </p>
                        </div>
                    </div> */}
                </div>

            </div>
        </div>
    );
};

export default AdvantagesOfPosp;
